import pluginTypes from "constants/pluginTypes";
import pathwayTypesConstants from 'constants/pathwayTypes';
import messages from "./messages";

const getSupportedPathwayOptions = (pluginType) => {
  const options = {
    [pluginTypes.LESSON]: [
      { pathwayType: pathwayTypesConstants.GRAPH, messages: messages.graph },
      { pathwayType: pathwayTypesConstants.LINEAR, messages: messages.linear },
      { pathwayType: pathwayTypesConstants.FREE, messages: messages.free },
    ],
    default: [
      { pathwayType: pathwayTypesConstants.LINEAR, messages: messages.linear },
      { pathwayType: pathwayTypesConstants.FREE, messages: messages.free },
    ],
  };
  return options[pluginType] || options.default;
};

/**
 * Returns an array of pathway options filtered by allowed types.
 *
 * @param {string} pluginType - The type of plugin.
 * @param {Array.<string>} allowedTypes - The list of allowed pathway types.
 * @returns {Array.<Object>} The filtered list of pathway options.
 * @console {Error} If the `AllowedTypes` has unsupported options only, or if any supported option is not included in the `AllowedTypes`.
 */

export const getPathwayOptions = (pluginType, allowedTypes) => {
  const supportedOptions = getSupportedPathwayOptions(pluginType);
  
  const hasAllowedTypes = Array.isArray(allowedTypes) && allowedTypes.length;
  if (!hasAllowedTypes) return supportedOptions;

  // Check for duplicates
  const uniqueAllowedTypes = [... new Set(allowedTypes)];
  if (uniqueAllowedTypes.length !== allowedTypes.length) {
    // eslint-disable-next-line no-console
    console.error(`Duplicate values detected in the allowedTypes array of source plugin: ${allowedTypes}`);
  }
  
  const optionsOverride = uniqueAllowedTypes.map((type) => type.toLowerCase());
  
  const actualOptions = supportedOptions.filter((options) => optionsOverride.includes(options.pathwayType.toLowerCase()));
  if (!actualOptions.length) {
  // eslint-disable-next-line no-console
    console.error(
      `Ignoring allowedTypes from source plugin schema of ${pluginType} as it has unsupported options only, 
    SupportedOptions: ${supportedOptions.map((options) => options.pathwayType.toLowerCase())},
    ReceivedOptions: ${optionsOverride}`,
    );
    return supportedOptions; 
  }

  if (actualOptions.length < optionsOverride.length) {
    // eslint-disable-next-line no-console
    console.error(
      `Please Remove Unsupported options from allowedTypes from source plugin schema ${pluginType}, 
    SupportedOptions: ${supportedOptions.map((options) => options.pathwayType.toLowerCase())},
    ReceivedOptions: ${optionsOverride}`,
    );
  }
  return actualOptions;
};
